import { cn } from '@landler/component-library';
import { FC, HTMLAttributes } from 'react';

type IconProps = {
  icon: string;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const Icon: FC<IconProps> = ({ icon, className, ...delegated }) => {
  return <i className={cn(icon, className)} {...delegated} />;
};
